import { useCallback, useEffect, useRef } from 'react';

import {
  createMathJaxTimer,
  trackMathJaxRerendering,
} from '../../../utils/newrelic-mathjax';
import { getFormulaCount } from '../utils';

export const useMathJaxRenderer = () => {
  const activeOperations = useRef(new Set<() => void>());

  const rerenderMath = useCallback(
    async (targetElements?: Element[]): Promise<void> => {
      if (!window.MathJax?.typesetPromise || typeof window === 'undefined')
        return;

      const operation = async () => {
        const timer = createMathJaxTimer();
        const formulaCount = targetElements
          ? targetElements.length
          : getFormulaCount();

        try {
          if (targetElements && targetElements.length > 0) {
            await window.MathJax!.typesetPromise!(targetElements);
          } else {
            await window.MathJax!.typesetPromise!();
          }

          const renderTime = timer.end();
          trackMathJaxRerendering.success(formulaCount, renderTime);
        } catch (error) {
          console.error('❌ MathJax re-rendering error:', error);
          trackMathJaxRerendering.failure(error as Error);
        }
      };

      activeOperations.current.add(operation);

      try {
        await operation();
      } finally {
        activeOperations.current.delete(operation);
      }
    },
    []
  );

  useEffect(() => {
    const currentActiveOperations = activeOperations.current;

    return () => {
      currentActiveOperations.clear();
    };
  }, []);

  return { activeOperations, rerenderMath };
};